module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_product":"Select Product","hide_variant_add_on":"Hide variant and add-on products"},"id":{"select_product":"Pilih Produk","hide_variant_add_on":"Sembunyikan varian dan produk tambahan"}}')
  delete Component.options._Ctor
}
